var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.pessoaLogada)?_c('BotaoVoltar',{attrs:{"url":'/Hospede/Bemvindo'}}):_c('BotaoVoltar',{attrs:{"url":'/'}}),_c('Subtitulo',{attrs:{"subtitulo":_vm.$t('locais.texto')}}),_c('PdvList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }